import { t } from '@muraletta/i18n';
// Storefront-only enhancements. No requests to the generation service.
function initStorefront(root = document) {
  root.querySelectorAll('[data-muraletta-rail]').forEach(rail => {
    if (rail.dataset.ready) return;
    rail.dataset.ready = 'true';
    const scroller = rail.querySelector('.muraletta-product-rail__scroller');
    if (!scroller) return;
    const buttons = [...rail.querySelectorAll('[data-rail-direction]')];
    const rtl = getComputedStyle(scroller).direction === 'rtl';
    const refresh = () => buttons.forEach(button => {
      button.hidden = scroller.scrollWidth <= scroller.clientWidth + 2;
      const offset=Math.abs(scroller.scrollLeft),maximum=scroller.scrollWidth-scroller.clientWidth;
      const atLeft=rtl?offset>=maximum-1:offset<=1;
      const atRight=rtl?offset<=1:offset>=maximum-1;
      button.disabled = Number(button.dataset.railDirection) < 0 ? atLeft : atRight;
    });
    buttons.forEach(button => button.addEventListener('click', () => {
      const card = scroller.querySelector('article');
      scroller.scrollBy({ left: ((card?.offsetWidth || 236) + 16) * 3 * Number(button.dataset.railDirection), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }));
    scroller.addEventListener('scroll', refresh, { passive: true });
    rail.addEventListener('muraletta:country-updated', refresh);
    new ResizeObserver(refresh).observe(scroller);
    refresh();
  });
  root.querySelectorAll('[data-muraletta-tabs]').forEach(group => {
    if (group.dataset.ready) return;
    group.dataset.ready = 'true';
    const tabs = [...group.querySelectorAll('[data-spec-tab]')];
    const activate = target => tabs.forEach(tab => {
      const active = tab === target;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
      document.getElementById(tab.getAttribute('aria-controls')).hidden = !active;
    });
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === t('Home')) next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        activate(tabs[next]);
        tabs[next].focus();
      });
    });
  });
}
initStorefront();
document.addEventListener('shopify:section:load', event => initStorefront(event.target));
// Preserve product context when the customer chooses to report an artwork detail.
const productContext = new URLSearchParams(location.search).get('produit');
const contactBody = document.querySelector('textarea[name="contact[body]"]');
if (contactBody && !contactBody.value && productContext && /^[a-z0-9-]{1,180}$/.test(productContext)) {
  contactBody.value = `${t('Bonjour, je souhaite signaler un détail sur cette affiche :')}\n${location.origin}${window.Shopify?.routes?.root || '/'}products/${productContext}\n\n`;
}
